var api_url = "http://localhost:3068/api/"
var socket_url = 'http://localhost:3068'
// api_url ="https://devapi.360inventory.app/api/"
var server = false;
if (['master001.sipro.app', 'master001.sipro.app'].includes(window.location.host)) {
    server = true;
}

if (server) {
    api_url = "https://api.sipro.app/api/"
    socket_url = 'https://api.sipro.app'
}




export { api_url, socket_url };